module.exports = __webpack_public_path__ + "static/media/facebook messenger_messenger logo_icon.6d6bbdaa.png";